import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Container,
  IconButton,
  useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';
import {CloseModalIcon} from '@salesforce/retail-react-app/app/components/icons';
import Search from '@amblique/king-living/app/components/search';

/**
 * @override
 * - Add initialFocusRef to auto-focus search input when modal opens
 * - Add ModalOverlay with custom positioning to not cover header
 * - Pass inputRef to Search component for focus management
 */
const SearchModal = ({isOpen, onClose}) => {
  const styles = useMultiStyleConfig('SearchModal');
  const searchInputRef = useRef(null);

  // Extract containerProps from modal styles for proper positioning
  const {containerProps, blockScrollOnMount, ...modalProps} = styles.modal || {};

  return (
    <Modal
      isOpen={isOpen}
      scrollBehavior="inside"
      size="full"
      onClose={onClose}
      initialFocusRef={searchInputRef}
      blockScrollOnMount={blockScrollOnMount ?? false}
      {...(containerProps && {containerProps})}
      {...modalProps}
    >
      <ModalOverlay {...styles.overlay} />
      <ModalContent {...styles.content}>
        <IconButton
          aria-label="Close search"
          icon={<CloseModalIcon h="18px" w="18px" />}
          variant="ghost"
          onClick={onClose}
          {...styles.closeButton}
        />
        <ModalBody {...styles.body}>
          <Container {...styles.container}>
            <Search inputRef={searchInputRef} onCloseModal={onClose} />
          </Container>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

SearchModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SearchModal;
